/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { z } from 'zod';
import { baseChallengeTranslationBodySchema } from '../challenge-translation-body-schema';

export const updateChallengeTranslationBodySchema = baseChallengeTranslationBodySchema.partial();

export type IUpdateChallengeTranslationBody = z.infer<typeof updateChallengeTranslationBodySchema>;

export interface IUpdateChallengeTranslationRequest {
  challengeId: number;
  translationId: number;
  body: IUpdateChallengeTranslationBody;
}
